export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen w-full flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-[#002B5C] via-[#1565C0] to-[#002B5C]">
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0l25.98 15v30L30 60 4.02 45V15z' fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      <div className="absolute right-0 top-0 bottom-0 w-[45%] h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/a44f7fb2c7d0c384aea606825124810f.jpg"
          alt="Laboratory Research"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-[#002B5C]/20 to-[#002B5C]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-2xl">
          <h1 className="text-7xl font-extralight text-white mb-6 leading-tight">
            InovaBioCorp
          </h1>
          <p className="text-3xl italic text-[#FFD700] mb-4 font-serif">
            Science by Scientists, for Scientists
          </p>
          <p className="text-base text-white/80 mb-12 font-light">
            Medical Devices | Pharmaceuticals | Research Excellence
          </p>
          <a
            href="#about"
            className="inline-block px-10 py-4 bg-white text-[#002B5C] rounded-full text-base font-medium hover:bg-[#FFD700] hover:text-[#002B5C] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Explore Our Divisions
          </a>
        </div>
      </div>
    </section>
  );
}